import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const modalStyles = css`
  width: 65.6rem;
  max-width: calc(100vw - 4.8rem);
  max-height: 68rem;
  min-height: 52rem;
`;

export const nestedDialogClass = {
  paper: cn(modalStyles, 'h-full'),
};
